export default __webpack_public_path__ + "static/media/0x2628568509e87c4429fbb5c664ed11391be1bd29.2a113994.svg";